export const SELECTED_SCHEME_DETAILS = "SELECTED_SCHEME_DETAILS";
export const SEED_SCHEME_DETAILS = "SEED_SCHEME_DETAILS";
export const GRM_FARMER_DETAILS = "GRM_FARMER_DETAILS";
export const SELECTED_WEATHER_LOCATION = "SELECTED_WEATHER_LOCATION";
export const SOIL_HEALTH_CARDS = "SOIL_HEALTH_CARDS";
export const SOIL_HEALTH_CARD_DBTID = "SOIL_HEALTH_CARD_DBTID";
export const SOIL_HEALTH_CARD_TEST_GRID = "SOIL_HEALTH_CARD_TEST_GRID";
export const USER_PROFILE = "USER_PROFILE";
